if (typeof BSS_B2B !== "undefined" && BSS_B2B) {
   setTimeout(() => {
      const isPDP = window.location.pathname.includes("/products/");
      if (isPDP) {
         let oldHref = location.href;
         new MutationObserver(() => {
            if (oldHref !== location.href) {
               oldHref = location.href;
               const variant = document.querySelector("[bss-b2b-product-form] form input[name='id']")?.getAttribute("value");
               setTimeout(() => {
                  const productForm = document.querySelector("[bss-b2b-main-product-form]");
                  BSS_B2B.observer.productSubject.notifyObserver("VariantChange", "VariantSelectChange", {
                     productForm,
                  });
               }, 600);
            }
         }).observe(document, {
            subtree: true,
            childList: true,
         });
      }
   }, 3000);

   setTimeout(() => {
      updateB2BVariantPrice();
   }, 6000);

   function updateB2BVariantPrice() {
      const form = document.querySelector("[bss-b2b-main-product-form]");
      const productFormId = form.getAttribute("bss-b2b-product-form-id");
      const product = BSS_B2B.storage.productFormStorage.get(productFormId);
      const variantInput = document.querySelector("[bss-b2b-product-form] form input[name='id']");
      const variantId = Number(variantInput.getAttribute("value"));
      const variant = BSS_B2B.storage.variantStorage.get(variantId);
      product.currentVariant = variant;
      BSS_B2B.storage.productFormStorage.set(productFormId, product);
      BSS_B2B.pl.utils.product.showPrice(productFormId, variantId);
   }

   setTimeout(() => {
      const observer = new MutationObserver((MutationList) => {
         // console.log(MutationList)
         for (let item of MutationList) {
            if (item.target.id === "search-result") {
               handleCartDrawerFooterMutation();
            }
         }
      });
      observer.observe(document.body, {
         childList: true,
         subtree: true,
      });
   }, 300);

   async function handleCartDrawerFooterMutation() {
      if (BSS_B2B) {
         const res = await BSS_B2B?.storage?.productStorage.load();
         if (res) {
            if (res.notExistProductIds?.length || res.productIds?.length || res.variantIds?.size) {
               BSS_B2B.observer?.productSubject?.notifyObserver("LazyProduct", "LoadedLazyProduct", {
                  ...res,
               });
            }
         }
      }
   }

   // Affichage des prix HT pour les clients B2B
   // BSS injecte les prix TTC ; on les intercepte et on affiche les valeurs HT
   (function setupHTDisplay() {
      const isB2BCustomer = document.body?.getAttribute("data-is-b2b-customer") === "true";
      if (!isB2BCustomer) return;

      const PRICE_SEL = "[bss-b2b-product-price], [bss-b2b-item-original-price]";

      function fmt(cents) {
         if (window.Shopify?.formatMoney) {
            return Shopify.formatMoney(cents, Shopify.moneyFormat || "{{amount_with_comma_separator}} €");
         }
         return new Intl.NumberFormat("fr-FR", { style: "currency", currency: "EUR" }).format(cents / 100);
      }

      function toCents(text) {
         const clean = text.replace(/[^\d,]/g, "").replace(",", ".");
         const n = parseFloat(clean);
         return isNaN(n) ? 0 : Math.round(n * 100);
      }

      function getTaxDivisor(el) {
         const rate = parseFloat(el.getAttribute("data-b2b-tax-rate") || "20");
         return rate / 100 + 1;
      }

      function updateCartButton(htP) {
         const btns = document.querySelectorAll(".add_to_cart_button .button-text");
         for (const btn of btns) {
            const walker = document.createTreeWalker(btn, NodeFilter.SHOW_TEXT);
            let node;
            while ((node = walker.nextNode())) {
               const match = node.textContent.match(/([^\d]*)([\d]+[,.][\d]+)\s*€(?!\s*HT)/);
               if (match) {
                  node.textContent = node.textContent.replace(match[0], `${match[1]}${fmt(htP)} HT`);
                  break;
               }
            }
         }
      }
    
      function updateProgressBar() {
         const progressEl = document.querySelector("[data-b2b-progress]");
         if (!progressEl) return;

         // Reconvertit les prix HT affichés → TTC pour obtenir le vrai total B2B
         let ttcCents = 0;
         document.querySelectorAll("tr[bss-b2b-cart-item-key]").forEach((row) => {
            const priceEl = row.querySelector("[bss-b2b-item-original-price]");
            const qtyInput = row.querySelector("input.cart-qty");
            if (!priceEl || !qtyInput) return;
            const priceSpan = priceEl.querySelector(":scope > span");
            if (!priceSpan) return;
            const htCents = toCents(priceSpan.textContent);
            if (!htCents) return;
            const taxDivisor = getTaxDivisor(priceEl);
            ttcCents += Math.round(htCents * taxDivisor) * (parseInt(qtyInput.value) || 1);
         });

         if (!ttcCents) return;

         const cartTotalEuros = ttcCents / 100;
         const tiersRaw = progressEl.getAttribute("data-b2b-tiers") || "";
         const successMsg = progressEl.getAttribute("data-b2b-success") || "";

         // Parse le format "montant|message" ligne par ligne
         const tiers = [];
         for (const line of tiersRaw.split(/\r?\n/)) {
            const entry = line.trim();
            if (!entry) continue;
            const sepIdx = entry.indexOf("|");
            const threshStr = (sepIdx >= 0 ? entry.slice(0, sepIdx) : entry).trim().replace(",", ".");
            const thresh = parseFloat(threshStr);
            if (isNaN(thresh) || thresh <= 0) continue;
            tiers.push({ threshold: thresh, message: sepIdx >= 0 ? entry.slice(sepIdx + 1).trim() : "" });
         }

         if (!tiers.length) return;

         const highestThreshold = Math.max(...tiers.map((t) => t.threshold));
         let nextThreshold = 0;
         let nextMessage = "";
         let minRemaining = Infinity;

         for (const tier of tiers) {
            const remaining = tier.threshold - cartTotalEuros;
            if (remaining > 0 && remaining < minRemaining) {
               minRemaining = remaining;
               nextThreshold = tier.threshold;
               nextMessage = tier.message;
            }
         }

         const progressMax = nextThreshold > 0 ? nextThreshold : highestThreshold;
         const percent = Math.min(100, Math.max(0, Math.round((cartTotalEuros / progressMax) * 1000) / 10));

         let displayMessage = nextThreshold > 0 ? nextMessage : successMsg;
         if (displayMessage) {
            const remainingCents = minRemaining !== Infinity ? Math.round(minRemaining * 100) : 0;
            displayMessage = displayMessage
               .replace("[remaining]", remainingCents ? fmt(remainingCents) : "")
               .replace("[current]", fmt(ttcCents))
               .replace("[target]", fmt(Math.round(progressMax * 100)));
         }

         window.dispatchEvent(new CustomEvent("b2b-progress-update", { detail: { percent } }));

         const msgEl = progressEl.querySelector("[data-b2b-progress-msg]");
         if (msgEl && displayMessage) msgEl.textContent = displayMessage;
      }

      function transform(el) {
         const spans = [...el.querySelectorAll(":scope > span")];
         if (!spans.length) return;

         let priceSpan = null,
            caSpan = null;
         for (const s of spans) {
            if (s.style.textDecoration?.includes("line-through")) caSpan = s;
            else priceSpan = s;
         }
         if (!priceSpan) return;

         const pCents = toCents(priceSpan.textContent);
         if (!pCents) return;

         const taxDivisor = getTaxDivisor(el);
         const caCents = caSpan ? toCents(caSpan.textContent) : 0;
         const htP = Math.round(pCents / taxDivisor);
         const htCa = caCents > pCents ? Math.round(caCents / taxDivisor) : null;

         // Réinitialise la couleur BSS sur le conteneur
         el.style.color = "";

         const unit = el.querySelector(":scope > small");

         if (el.hasAttribute("bss-b2b-product-price")) {
            // Page produit : "Prix public" en TTC au-dessus (barré), puis HT + TTC en petit
            const oldPriceLabel = el.getAttribute("data-label-old-price") || "Prix public";
            let html = "";
            if (htCa) {
               html += `<div class="b2b-old-price text-sm mb-1"><s class="opacity-60">${oldPriceLabel} : ${fmt(caCents)} TTC</s></div>`;
            }
            html += `<span style="font-weight:600">${fmt(htP)} HT</span>`;
            html += `<small class="b2b-ttc-price ml-1 opacity-70">${fmt(pCents)} TTC</small>`;
            el.innerHTML = html;
         } else {
            // Article du panier : HT en principal + TTC en petit
            el.innerHTML = `<span style="font-weight:600">${fmt(htP)} HT</span>`;
            el.innerHTML += `<small class="b2b-ttc-price ml-1 opacity-70">${fmt(pCents)} TTC</small>`;
         }

         // Prix unitaire TTC
         if (unit) {
            const parts = unit.textContent.split("/");
            if (parts.length >= 2) {
               const unitCents = toCents(parts[0]);
               if (unitCents > 0) {
                  unit.textContent = `${fmt(unitCents)} / ${parts.slice(1).join("/").trim()}`;
                  unit.style.color = "";
               }
            }
            el.appendChild(unit);
         }

         // Bouton ajouter au panier (uniquement pour les prix produit, pas les articles du panier)
         if (el.hasAttribute("bss-b2b-product-price")) {
            updateCartButton(htP);
         }
      }

      const obs = new MutationObserver((mutations) => {
         const targets = new Set();
         for (const m of mutations) {
            const t = m.target.closest?.(PRICE_SEL) || (m.target.hasAttribute?.("bss-b2b-product-price") || m.target.hasAttribute?.("bss-b2b-item-original-price") ? m.target : null);
            if (t) targets.add(t);
         }
         if (!targets.size) return;

         // Arrêter l'observation AVANT de transformer (évite la boucle infinie)
         obs.disconnect();
         targets.forEach((el) => {
            // Ne transformer que si c'est encore le format original (pas "HT" dedans = pas encore transformé)
            const text = el.textContent || "";
            if (!text.includes(" HT")) {
               // Si pas "HT", c'est du prix brut de BSS à transformer
               transform(el);
            }
         });

         // Reprendre l'observation après une courte pause
         setTimeout(() => {
            document.querySelectorAll(PRICE_SEL).forEach((el) => obs.observe(el, { childList: true, subtree: true }));
            updateProgressBar();
         }, 0);
      });

      // Surveille les nouveaux éléments ajoutés dynamiquement (scroll infini, quick view, ouverture du panier…)
      new MutationObserver((mutations) => {
         for (const m of mutations) {
            for (const n of m.addedNodes) {
               if (n.nodeType !== 1) continue;
               const isPrice = n.hasAttribute?.("bss-b2b-product-price") || n.hasAttribute?.("bss-b2b-item-original-price");
               [...(isPrice ? [n] : []), ...n.querySelectorAll(PRICE_SEL)].forEach((el) => obs.observe(el, { childList: true, subtree: true }));
            }
         }
      }).observe(document.body, { childList: true, subtree: true });

      setTimeout(() => {
         document.querySelectorAll(PRICE_SEL).forEach((el) => {
            obs.observe(el, { childList: true, subtree: true });
            transform(el);
         });
         updateProgressBar();
      }, 1500);
   })();
}

// Masquer les grands formats vrac (5kg+) pour les clients non-B2B
// HORS du bloc BSS_B2B — s'exécute pour tous les visiteurs
(function hideProVariants() {
  // Ne rien faire pour les clients B2B — ils voient tous les formats
  const isB2BCustomer = document.body?.getAttribute("data-is-b2b-customer") === "true";
  if (isB2BCustomer) return;

  const proWeightsKg = [5, 10, 15, 20, 25];

  function hideVariants() {
    document.querySelectorAll('input[type="radio"]').forEach(function(input) {
      const match = input.value.match(/^(\d+)\s*kilogramme/i);
      if (match && proWeightsKg.includes(parseInt(match[1]))) {
        input.disabled = true;
        if (input.id) {
          const btn = document.querySelector('label[for="' + CSS.escape(input.id) + '"]');
          if (btn) btn.style.setProperty('display', 'none', 'important');
        }
      }
    });
  }

  const observer = new MutationObserver(hideVariants);
  observer.observe(document.body, { childList: true, subtree: true });
  window.addEventListener('load', hideVariants);
  setTimeout(hideVariants, 500);
  setTimeout(hideVariants, 1500);
  setTimeout(function() { observer.disconnect(); }, 10000);
})();